<template>
  <div class="confirm-dialog">
    <el-dialog :custom-class="type === 'with-title' ? 'with-title' : ''" :title="title" :visible.sync="visible"
      ><span v-if="content">{{ content }}</span
      ><span class="dialog-footer" slot="footer">
        <el-button @click="confirmClick(false)">キャンセル</el-button>
        <el-button type="primary" @click="confirmClick(true)">OK</el-button></span
      ></el-dialog
    >
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.el-dialog__footer {
  .el-button {
    width: $spacing-unit * 15;
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  data() {
    return {
      visible: false,
      title: '',
      content: '',
      type: 'default',
      confirm: (() => {
        return
      }) as (confirm: boolean) => void
    }
  },
  methods: {
    confirmClick(confirm: boolean) {
      this.visible = false
      this.confirm(confirm)
    },
    /**
     *
     * @param {string} title タイトル
     * @param {string} content 内容
     * @param {string} type タイプ default | with-title
     * @param {Function} callback コールバック
     */
    open(title: string, content: string, type: string, callback: (confirm: boolean) => void) {
      this.title = title
      this.content = content
      this.type = type
      if (!this.type) {
        this.type = 'default'
      }
      this.confirm = callback
      this.visible = true
    },
    close() {
      this.visible = false
    }
  }
})
</script>
